/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type IncomeAlimonyProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function IncomeAlimony({ submitProps, product }: IncomeAlimonyProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Einnahmen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasIncomeAlimony"}
                question={"Erhalten Sie Unterhalt?"}
                modalContent={
                  <p>
                    Unterhalt erhalten Sie zum Beispiel von Eltern, Kindern, Ehegatten, Lebenspartnern. Bitte geben Sie auch dann "ja" an, wenn Sie den
                    Unterhalt nicht als Geldleistungen sondern durch freie Wohnung, Verpflegung oder sonstige Versorgung im elterlichen Haushalt oder ähnliches
                    erhalten. In diesem Fall geben Sie bitte den geschätzten Wert an.
                  </p>
                }
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasIncomeAlimony === "yes" && (
              <NumberFieldConfigured caseData={product} fieldPath={"incomeAlimonyAmount"} fieldType={"money"} numberType={"float"} required />
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
